export default __webpack_public_path__ + "static/media/Info.44b7a3f1.svg";